module.exports = __webpack_public_path__ + "img/n-h-page3-6.318f15f4.png";